import React, { useState } from "react";
import { useSelector } from "react-redux";

import { VISIT_CHECK, VISIT_PENDING } from "../../../api/allApi_List";
import VisitPendingList from "../components/pendingList/VisitPendingList";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import useCheckData from "../../../CustomHooks/useAxios/useCheckData";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";

const VisitPendingPage = () => {
  const { isLoaded } = useFetchData(VISIT_PENDING);
  const [viewDialogDetails, setViewDialogDetails] = useState({});
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;

  const {
    confirmDialogBox,
    setConfirmDialogBox,
    setBodyData,
    isActionSucceed,
    setIsActionSucceed,
    buttonStatus,
    setButtonStatus,
    handleCheck,
    checkResponseData,
    checkedErr,
    setCheckedErr,
    checkLoading,
  } = useCheckData("post", VISIT_CHECK);

  // handle confirm dialog box on complaint check
  const handleConfirmDialogBox = (id, status) => {
    setViewDialogDetails({ ...viewDialogDetails, open: false });
    setConfirmDialogBox(true);
    setBodyData((prev) => {
      return { id: id, status: status };
    });
    setButtonStatus(status);
  };
  return (
    <MainPageLayout
      headerConfig={{ title: "Visit Pending" }}
      numberOfData={dataLength}
    >
      {isLoaded && !error ? (
        <VisitPendingList
          viewDialogDetails={viewDialogDetails}
          setViewDialogDetails={setViewDialogDetails}
          handleConfirmDialogBox={handleConfirmDialogBox}
          confirmDialogBox={confirmDialogBox}
          setConfirmDialogBox={setConfirmDialogBox}
          isActionSucceed={isActionSucceed}
          checkResponseData={checkResponseData}
          setIsActionSucceed={setIsActionSucceed}
          buttonStatus={buttonStatus}
          handleCheck={handleCheck}
          checkLoading={checkLoading}
          setBodyData={setBodyData}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {checkedErr && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(checkedErr)}
          closeAction={() => setCheckedErr("")}
        />
      )}
    </MainPageLayout>
  );
};

export default VisitPendingPage;
